export enum BigQueryJobName {
  AccountCreditWrite = 'account-credit.write',
  AppointmentWrite = 'appointment.write',
  BrandWrite = 'brand.write',
  ContactWrite = 'contact.write',
  InvoiceWrite = 'invoice.write',
  TransactionWrite = 'transaction.write',
  LabWrite = 'lab.write',
  LabJobWrite = 'lab-job.write',
  LabJobStatusUpdate = 'lab-job.status.update',
  LabJobReceived = 'lab-job.received',
  PatientWrite = 'patient.write',
  PatientInteractionWrite = 'patient-interaction.write',
  PaymentPlanWrite = 'payment-plan.add',
  PaymentPlanStatusUpdate = 'payment-plan.status.update',
  PracticeWrite = 'practice.write',
  StafferWrite = 'staffer.write',
  TaskWrite = 'task.write',
  TaskCompleted = 'task.completed',
  TaskEvent = 'task.status.update',
  TeamWrite = 'team.write',
  TreatmentPlanWrite = 'treatment-plan.write',
  TreatmentPlanCompleted = 'treatment-plan.completed',
  TreatmentPlanStatusUpdate = 'treatment-plan.status.update',
  TreatmentStepWrite = 'treatment-step.write',
  ScheduleSummaryWrite = 'schedule-summary.write',
  SchedulingEventWrite = 'scheduling-event.write',
  SchedulingEventReasonWrite = 'scheduling-event-reason.write',
}

/**
 * These Jobs currently have no listeners and shouldn't be used we implement
 * something that intends to consume the job.
 */
export enum BigQueryJobNameUnused {
  GeneralNoteAdd = 'general.note.add',
  TaskReopened = 'task.reopened',
  AccountCreditAdd = 'account-credit.add',
  AccountCreditUse = 'account-credit.use',
  AppointmentCompleted = 'appointment.completed',
  AppointmentFollowUpAdd = 'appointment.follow-up.add',
  AppointmentWaitListAdd = 'appointment.wait-list.update',
  AppointmentDependencyAdd = 'appointment.dependency.add',
  CalendarEventAdd = 'calendar-event.add',
  CalendarEventRescheduled = 'calendar-event.rescheduled',
  CalendarEventParticipantAdd = 'calendar-event.participant.add',
  CalendarEventParticipantRemove = 'calendar-event.participant.remove',
  GeneralMentionAdd = 'general.mention.add',
  GeneralInteractionAdd = 'general.interaction.add',
  PatientNoteAdd = 'patient.note.add',
  PatientRelationshipAdd = 'patient.relationship.add',
  PaymentPlanCompleted = 'payment-plan.completed',
  PaymentPlanInvoiceAdd = 'payment-plan.invoice.add',
  RecurringTaskAdd = 'recurring-task.add',
  SchedulingAlertAdd = 'scheduling-alert.add',
  SchedulingAlertRemove = 'scheduling-alert.remove',
  TaskRemoved = 'task.remove',
  TaskReassigned = 'task.reassigned',
  TaskMention = 'task.mention',
  TreatmentPlanFollowUpAdd = 'treatment-plan.follow-up.add',
}

export type AnyBigQueryJobName = BigQueryJobName | BigQueryJobNameUnused;
